/**
 * MOCKUP HUB — Anteprima visiva centralizzata di tutto HostFix nel "look del futuro".
 * Route: /mockup
 * Standalone, niente auth, nessuna integrazione live.
 */
import React, { useState } from 'react';
import {
  Wrench, LogIn, LayoutDashboard, UserCircle, ListChecks, FileText,
  Activity, Calendar, Siren, Smartphone, ChevronRight, Sparkles, Eye,
  Building2, MapPin, UserCog, Users, Plus, AlertOctagon, Newspaper,
  BarChart3, FileCheck, Settings, Palette
} from 'lucide-react';
import { C, fontHead, primaryBtn, applyTheme, themes } from './_tokens';
import MockupFrontOffice from '../MockupFrontOffice';
import MockupSuperAdmin from '../MockupSuperAdmin';
import ScreenLogin from './screens/ScreenLogin';
import ScreenTickets from './screens/ScreenTickets';
import ScreenTicketDetail from './screens/ScreenTicketDetail';
import ScreenConsumi from './screens/ScreenConsumi';
import { ScreenScheduled, ScreenEmergencies, ScreenMobileFO } from './screens/ScreenOthers';
import {
  ScreenHotelManager, ScreenHeatmap, ScreenNewTicket, ScreenTechnician,
  ScreenHousekeeping, ScreenUsers, ScreenHotels, ScreenBacheca,
  ScreenElevators, ScreenContracts, ScreenAnalytics, ScreenProfile
} from './screens/ScreenMore';
import {
  ScreenBoardLive, ScreenPredictive, ScreenTechProd, ScreenNotifSettings,
  ScreenOnlineUsers, ScreenPatchNotes, ScreenSystemHealth, ScreenCluster,
  ScreenInvestor, ScreenAdminTools, ScreenSchedDetail
} from './screens/ScreenLive';

const GROUPS = [
  {
    label: 'Accesso & Sistema',
    items: [
      { id: 'login',   label: 'Login',                 icon: LogIn,           comp: ScreenLogin,           note: 'Prima impressione' },
    ],
  },
  {
    label: 'Dashboard',
    items: [
      { id: 'admin',    label: 'Super Admin · Command', icon: LayoutDashboard, comp: MockupSuperAdmin,      note: 'Vista gruppo' },
      { id: 'hmgr',     label: 'Hotel Manager',         icon: Building2,       comp: ScreenHotelManager,    note: 'Singolo hotel' },
      { id: 'fo',       label: 'Front Office',          icon: UserCircle,      comp: MockupFrontOffice,     note: 'Reception desktop' },
      { id: 'tech',     label: 'Tecnico · I miei lavori', icon: UserCog,       comp: ScreenTechnician,      note: 'Coda interventi' },
      { id: 'hk',       label: 'Housekeeping',          icon: Sparkles,        comp: ScreenHousekeeping,    note: 'Segnalaz. rapida' },
    ],
  },
  {
    label: 'Ticketing',
    items: [
      { id: 'tlist',    label: 'Tutti i Ticket',        icon: ListChecks,      comp: ScreenTickets,         note: 'Tabella pro' },
      { id: 'tdet',     label: 'Dettaglio Ticket',      icon: FileText,        comp: ScreenTicketDetail,    note: 'Singolo intervento' },
      { id: 'tnew',     label: 'Nuovo Ticket · modal',  icon: Plus,            comp: ScreenNewTicket,       note: 'Form creazione' },
    ],
  },
  {
    label: 'Manutenzione & Energia',
    items: [
      { id: 'sched',    label: 'Manutenzioni',          icon: Calendar,        comp: ScreenScheduled,       note: 'Calendar + Storico' },
      { id: 'schedd',   label: 'Dettaglio Manutenzione', icon: FileText,       comp: ScreenSchedDetail,     note: 'Checklist progress' },
      { id: 'predict',  label: 'Manut. Predittiva',     icon: Sparkles,        comp: ScreenPredictive,      note: 'Camere a rischio' },
      { id: 'cons',     label: 'Consumi & Energia',     icon: Activity,        comp: ScreenConsumi,         note: 'KPI · Trend · ROI' },
      { id: 'cntr',     label: 'Contratti',             icon: FileCheck,       comp: ScreenContracts,       note: 'Rinnovi & scadenze' },
      { id: 'elev',     label: 'Ascensori',             icon: AlertOctagon,    comp: ScreenElevators,       note: 'Live status' },
    ],
  },
  {
    label: 'Insights & Analytics',
    items: [
      { id: 'heat',     label: 'Heatmap problemi',      icon: MapPin,          comp: ScreenHeatmap,         note: 'Concentrazione guasti' },
      { id: 'analy',    label: 'Analytics & KPI',       icon: BarChart3,       comp: ScreenAnalytics,       note: 'Group performance' },
      { id: 'tprod',    label: 'Produttività Tecnici',  icon: UserCog,         comp: ScreenTechProd,        note: 'KPI per tecnico' },
      { id: 'clust',    label: 'Cluster Dashboard',     icon: Building2,       comp: ScreenCluster,         note: 'Confronto multi-hotel' },
    ],
  },
  {
    label: 'Gestione',
    items: [
      { id: 'hotels',   label: 'Hotel del Gruppo',      icon: Building2,       comp: ScreenHotels,          note: '6 properties' },
      { id: 'users',    label: 'Utenti & Ruoli',        icon: Users,           comp: ScreenUsers,           note: 'Gestione team' },
      { id: 'online',   label: 'Utenti Online',         icon: Wrench,          comp: ScreenOnlineUsers,     note: 'Live presence' },
      { id: 'bac',      label: 'Bacheca',               icon: Newspaper,       comp: ScreenBoardLive,       note: 'Comunicazioni team' },
      { id: 'emerg',    label: 'Rubrica Emergenze',     icon: Siren,           comp: ScreenEmergencies,     note: 'H24 contacts', danger: true },
    ],
  },
  {
    label: 'Sistema',
    items: [
      { id: 'health',   label: 'System Health',         icon: Activity,        comp: ScreenSystemHealth,    note: 'Stato servizi' },
      { id: 'notif',    label: 'Notifiche · settings',  icon: Newspaper,       comp: ScreenNotifSettings,   note: 'Preferences canali' },
      { id: 'patch',    label: 'Changelog · Patch',     icon: FileText,        comp: ScreenPatchNotes,      note: 'Release notes' },
      { id: 'tools',    label: 'Admin Tools',           icon: Settings,        comp: ScreenAdminTools,      note: 'Operazioni DB' },
      { id: 'prof',     label: 'Profilo & Settings',    icon: Settings,        comp: ScreenProfile,         note: 'Account utente' },
      { id: 'inv',      label: 'Investor Landing',      icon: FileCheck,       comp: ScreenInvestor,        note: 'Pagina commerciale' },
    ],
  },
];

const SCREENS = GROUPS.flatMap(g => g.items);

export default function MockupHub() {
  const [active, setActive] = useState('admin');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [themeName, setThemeName] = useState('corporate');
  const activeScreen = SCREENS.find(s => s.id === active);
  const ActiveComp = activeScreen?.comp;

  const handleThemeChange = (name) => {
    applyTheme(name);
    setThemeName(name);
  };

  return (
    <div key={themeName} style={{ display: 'flex', minHeight: '100vh', background: C.bg, color: C.text, fontFamily: 'Inter' }}>
      {/* HUB SIDEBAR */}
      {sidebarOpen && (
        <aside style={{
          width: 280, background: C.bgDeep, borderRight: `1px solid ${C.border}`,
          display: 'flex', flexDirection: 'column', padding: 24,
          position: 'sticky', top: 0, height: '100vh', overflowY: 'auto', flexShrink: 0,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 28 }}>
            <div style={{
              width: 38, height: 38, borderRadius: 11,
              background: `linear-gradient(135deg, ${C.gold}, ${C.goldDark})`,
              display: 'grid', placeItems: 'center',
              boxShadow: `0 0 24px ${C.goldGlow}`,
            }}><Wrench size={19} color={C.bg} strokeWidth={2.5} /></div>
            <div>
              <div style={{ fontFamily: fontHead, fontSize: 17, fontWeight: 600, letterSpacing: '-0.02em' }}>
                HostFix<span style={{ color: C.gold }}>.</span>
              </div>
              <div style={{ fontSize: 9.5, color: C.gold, letterSpacing: '0.2em',
                            textTransform: 'uppercase', fontWeight: 600 }}>Concept v1</div>
            </div>
          </div>

          <div style={{
            padding: 12, borderRadius: 12, marginBottom: 24,
            background: `linear-gradient(135deg, ${C.gold}11, transparent)`,
            border: `1px solid ${C.gold}44`,
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
              <Sparkles size={12} color={C.gold} />
              <span style={{ fontSize: 10, letterSpacing: '0.15em', textTransform: 'uppercase',
                             color: C.gold, fontWeight: 600 }}>Anteprima Mockup</span>
            </div>
            <div style={{ fontSize: 11.5, color: C.textSec, lineHeight: 1.5 }}>
              Layout statici per decidere se procedere col redesign.
              Codice live <b style={{ color: C.text }}>non toccato</b>.
            </div>
          </div>

          <div style={{ fontSize: 10, color: C.textSec, letterSpacing: '0.2em',
                        textTransform: 'uppercase', marginBottom: 10, paddingLeft: 6, fontWeight: 600 }}>
            Schermate · {SCREENS.length}
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {GROUPS.map(g => (
              <React.Fragment key={g.label}>
                <div style={{ padding: '12px 6px 4px', fontSize: 9.5, color: C.textDim,
                              letterSpacing: '0.18em', textTransform: 'uppercase', fontWeight: 600 }}>
                  {g.label}
                </div>
                {g.items.map(s => (
                  <button key={s.id} onClick={() => setActive(s.id)} style={{
                    display: 'flex', alignItems: 'center', gap: 11,
                    padding: '8px 11px', borderRadius: 8, cursor: 'pointer',
                    background: active === s.id ? `${C.gold}15` : 'transparent',
                    border: active === s.id ? `1px solid ${C.gold}33` : '1px solid transparent',
                    color: active === s.id ? C.gold : (s.danger ? '#FCA5A5' : C.textSec),
                    fontWeight: active === s.id ? 600 : 400, fontSize: 12.5,
                    textAlign: 'left', position: 'relative',
                  }}>
                    {active === s.id && <div style={{
                      position: 'absolute', left: -24, top: 7, bottom: 7, width: 3,
                      background: C.gold, borderRadius: '0 2px 2px 0',
                    }} />}
                    <s.icon size={13} strokeWidth={active === s.id ? 2.4 : 1.8} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.label}</div>
                      <div style={{ fontSize: 9.5, color: C.textDim, marginTop: 1,
                                    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.note}</div>
                    </div>
                    {active === s.id && <ChevronRight size={11} />}
                  </button>
                ))}
              </React.Fragment>
            ))}
          </div>

          <div style={{ flex: 1 }} />

          <div style={{ padding: 14, borderRadius: 12, background: C.surf,
                        border: `1px solid ${C.border}`, marginTop: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 10 }}>
              <Palette size={12} color={C.gold} />
              <span style={{ fontSize: 10, color: C.gold, letterSpacing: '0.15em',
                             textTransform: 'uppercase', fontWeight: 700 }}>Tema palette</span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {Object.entries(themes).map(([k, t]) => (
                <button key={k} onClick={() => handleThemeChange(k)} style={{
                  display: 'flex', alignItems: 'flex-start', gap: 10,
                  padding: '8px 10px', borderRadius: 8, textAlign: 'left', cursor: 'pointer',
                  background: themeName === k ? `${C.gold}15` : 'transparent',
                  border: themeName === k ? `1px solid ${C.gold}55` : `1px solid ${C.border}`,
                  color: C.text,
                }}>
                  <div style={{ display: 'flex', gap: 2, marginTop: 3 }}>
                    <span style={{ width: 8, height: 8, borderRadius: 2, background: t.gold }} />
                    <span style={{ width: 8, height: 8, borderRadius: 2, background: t.emerald }} />
                    <span style={{ width: 8, height: 8, borderRadius: 2, background: t.terra }} />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 11.5, fontWeight: 600,
                                  color: themeName === k ? C.gold : C.text }}>{t.name}</div>
                    <div style={{ fontSize: 9.5, color: C.textSec, marginTop: 2, lineHeight: 1.3 }}>{t.desc}</div>
                  </div>
                </button>
              ))}
            </div>
            <div style={{ fontSize: 10, color: C.textDim, marginTop: 12, paddingTop: 10,
                          borderTop: `1px solid ${C.border}`, lineHeight: 1.5 }}>
              <b style={{ color: C.gold }}>Light mode:</b> in roadmap (step 2)
            </div>
          </div>
        </aside>
      )}

      {/* MAIN SCREEN */}
      <main style={{ flex: 1, minWidth: 0, position: 'relative' }}>
        {/* Floating toggle when sidebar is closed */}
        {!sidebarOpen && (
          <button onClick={() => setSidebarOpen(true)} style={{
            position: 'fixed', top: 18, left: 18, zIndex: 100,
            padding: '8px 12px', background: C.surf,
            border: `1px solid ${C.border}`, borderRadius: 10,
            color: C.text, fontSize: 12, cursor: 'pointer',
            display: 'inline-flex', alignItems: 'center', gap: 6,
          }}><Eye size={13} /> Schermate</button>
        )}

        {/* Mockup label */}
        <div style={{
          position: 'fixed', top: 14, right: 18, zIndex: 100,
          background: 'rgba(212,175,55,0.15)', color: C.gold,
          border: `1px solid ${C.gold}`,
          padding: '5px 14px', borderRadius: 999, fontSize: 10.5,
          letterSpacing: '0.2em', fontWeight: 600, backdropFilter: 'blur(12px)',
        }}>MOCKUP · NON LIVE</div>

        <ActiveComp />
        {!ActiveComp && null}
      </main>
    </div>
  );
}
